const formatAccountNumber = (number) => {
    if(number){
        return number
            .replace(/\s+/g, "") // Remove all spaces
            .replace(/(\d{2})(\d{4})?(\d{4})?(\d{4})?(\d{4})?(\d{4})?(\d{4})?/g, (_, p1, p2, p3, p4, p5, p6, p7) =>
                [p1, p2, p3, p4, p5, p6, p7].filter(Boolean).join(" ")
            )
            .trim(); // Remove trailing spaces
    }
    return number
};

export default formatAccountNumber